module.exports = __webpack_public_path__ + "img/garry.370fd480.png";